<template>
  <div class="full-height">
    <!-- {{contact.meta_data.notes}} -->
    <b-overlay
      class="greedy full-height"
      :show="loadingContact"
      rounded="sm">
      <div slot="overlay">
        <Spinner/>
      </div>
      <div class="user-details-box full-height">
        <h3>Property details</h3>

        <ScrollArea
          ref="notesScrollbar"
          class="notes-scroll-area">
          <div
            v-for="(lead, index) in leads"
            :key="index"
            class="lead-box">
            <a
              :href="lead.url"
              target="_blank">
              <p class="domain">{{ lead.domain }}</p>
              <h2 v-if="lead.property">{{ lead.property }}</h2>
              <p
                class="message"
                :class="{'no-message': !lead.message || lead.message === ''}">{{ lead.message || 'No message left' }}</p>
              <p class="date">{{ lead.date }}</p>
              <icon
                name="external-link-alt"
                height="9px"/>
            </a>
          </div>
        </ScrollArea>
      </div>
    </b-overlay>
  </div>
</template>

<style lang="scss" scoped>
.user-details-box {
  .lead-box {
    margin: 15px;
    border-radius: 5px;
    border: solid 1px $greyBorder;
    background-color: $white;
    overflow: hidden;
    position: relative;

    &:hover {
      background: #f7f7f7;
    }

    h2 {
      margin-top: 5px!important;
        color: #30343a;
      font-weight: 500;
    }

    a {
      padding: 15px;
      display: block;
      text-decoration: none;
      position: relative;

      .domain {
        color: $stateGray;
        font-size: 12px;
      }
      .message {
        color: $blackPrimary;
        font-size: 14px;
        white-space: pre-line;
        &.no-message {
          color: $stateGray;
        }
      }
      .date {
        color: $stateGray;
        font-size: 12px;
        color: $stateGray;
        text-align: right;
      }
      .fa-icon {
        position: absolute;
        top: 12px;
        right: 6px;
        color: $stateGray;
      }
    }
  }
}
</style>

<script>
import { mapGetters } from 'vuex';
import randomString from '@/helpers/randomString';
import Spinner from '../../../common/Spinner';
import ScrollArea from '../../../common/ScrollArea';

export default {
  name: 'UserProperties',
  components: {
    Spinner,
    ScrollArea,
  },
  data() {
    return {
      notesPropertiesRegex: new RegExp('Received e-mail', 'g'),
      propertiesItems: [],
    };
  },
  computed: {
    ...mapGetters({
      contact: 'contact/contact',
      loadingContact: 'contact/loadingContact',
    }),
    /** Matches lead notes added via SMS. */
    leads() {
      return this.propertiesItems.map((property) => {
        const propertyRegex = new RegExp('Property:\\s*(.*?)\\s\\n', '');
        const referenceRegex = new RegExp('Reference:\\s*([\\w\\d_]+)\\s*(?:\\n)*', '');
        const uniqueReferenceRegex = new RegExp('Unique reference:\\s*([\\w\\d_]+)\\s\\n', '');
        const urlRegex = new RegExp('URL:\\s*((?:https?:)?(?:\\/\\/)?(?:[^@\\n]+@)?(?:www\\.)?([^:\\/\\n]+).*?\\s)', '');
        const commentRegex = new RegExp('Comment:\\s*(?:\\")*([\\w\\W\\n]*)(?:\\")*\\s*\\n', '');
        const contactedDateRegex = new RegExp('Contacted:\\s*([\\d\\-\\s:]+)', '');

        const propertyMatch = property.note.match(propertyRegex);
        const referenceMatch = property.note.match(referenceRegex);
        const uniqueReferenceMatch = property.note.match(uniqueReferenceRegex);
        const urlMatch = property.note.match(urlRegex);
        const commentMatch = property.note.match(commentRegex);
        const contactedDateMatch = property.note.match(contactedDateRegex);

        return {
          property: propertyMatch ? propertyMatch[1] : undefined,
          reference: referenceMatch ? referenceMatch[1] : undefined,
          uniqueReference: uniqueReferenceMatch ? uniqueReferenceMatch[1] : undefined,
          url: urlMatch ? urlMatch[1] : undefined,
          domain: urlMatch ? urlMatch[2] : undefined,
          message: commentMatch ? commentMatch[1] : undefined,
          date: contactedDateMatch ? contactedDateMatch[1] : undefined,
        };
      });
    },
  },
  watch: {
    contact() {
      // console.log('New contact selected');
      this.filterProperties();
    },
  },
  mounted() {
    this.notes = this.contact.meta_data.notes;
    this.filterProperties();
  },
  methods: {
    filterProperties() {
      this.propertiesItems = this.contact.meta_data.notes.map(note => (note.match(this.notesPropertiesRegex) ? note : null))
        .filter(note => note !== null)
        .map(note => ({ key: randomString(), note }));
    },
  },
};
</script>
